import { getHTMLDataTestID } from 'infra/utils'
import { FilterBarCategory, FilterBarItem } from 'procyon-ui'
import React from 'react'

const CheckboxFilter = ({ activeFilters = [], onActiveFilterChange }) => {
  const filterItems = [
    {
      label: 'Filter Type',
      filters: [
        {
          label: 'Applications',
          value: 'applications',
          checked: activeFilters.includes('applications')
        },
        {
          label: 'Git Server',
          value: 'git-server',
          checked: activeFilters.includes('git-server')
        }
      ]
    }
  ]

  const toggleResourceTypeFilter = (filter) => {
    let newFilters = []
    if (activeFilters.includes(filter)) newFilters = activeFilters.filter((e) => e !== filter)
    else newFilters = [filter, ...activeFilters]
    onActiveFilterChange && onActiveFilterChange(newFilters)
  }

  return (
    <div>
      {filterItems.map((e) => (
        <>
          <FilterBarCategory key={e.label} name={e.label}>
            {e.filters.map((filter) => (
              <FilterBarItem
                data-testid={getHTMLDataTestID('apps', 'div', 'filter-checkbox', filter.label)}
                key={filter.value}
                amount={filter.amount?.toString()}
                name={filter.label}
                checked={activeFilters.includes(filter.value)}
                onClick={() => toggleResourceTypeFilter(filter.value)}
              />
            ))}
          </FilterBarCategory>
        </>
      ))}
    </div>
  )
}

export { CheckboxFilter }
